define(["data/config", "framework/core/router"], function(config, router) {
    var canvasClassName = config.component.window.canvasClassName;
    var className = config.component.window.className;

    var makeWindow = function(params) {
        var $window = $("<div></div>").addClass(className);

        $window.params = params;

        if ($window.params.titlebar) {
            $window.append(
                '<div class="' +
                    className +
                    '-titlebar"><div class="' +
                    config.prefixes.component +
                    'uiTitleSub">' +
                    $window.params.title +
                    '</div><a class="' +
                    className +
                    '-titlebar-close"><i class="fas fa-times"></i></a></div>'
            );
            $window.on(
                "click",
                "." + className + "-titlebar-close",
                function() {
                    $window.trigger(config.events.windowRequestClose, {
                        isCancel: true
                    });
                }
            );
        }
        if ($window.params.width) {
            $window.addClass(
                className +
                    "--widthIs" +
                    $window.params.width.capitalizeFirstLetter()
            );
        }

        $window.params.text
            ? ($window.params.html =
                  '<p class="' +
                  config.prefixes.component +
                  'uiParagraph">' +
                  $window.params.text +
                  "</p>")
            : "";

        $window.params.autoscroll
            ? ($window.params.html = '<div class="c_dialog c_dialog--fullHeight"><div class="c_dialog-surface c_dialog-surface--scrolls">' + $window.params.html + '</div></div>')
            : '';

        $window.params.wrap
            ? $window.append(
                  '<div class="' +
                      className +
                      '-content">' +
                      params.html +
                      "</div>"
              )
            : $window.append(params.html);

        return $window;
    };

    var getParams = function(params) {
        if (params.url) {
            if (params.url.indexOf(":/") <= 0) {
                params.url = config.baseUrl + params.url;
            }
            params.route = router.getRouteFromUrl(params.url);
        }

        if (params.route && params.route.window) {
            for (var k in params.route.window) {
                if (params[k] === undefined) {
                    params[k] = params.route.window[k];
                }
            }
        }

        if (params.titlebar === undefined) {
            params.titlebar = true;
        }
        if (params.title === undefined) {
            params.title = "";
        }
        if (!params.urlArgs) {
            params.urlArgs = false;
        }

        return params;
    };

    var Window = function(_params) {
        /*private api*/
        var $loading = $(
            '<div class="' +
                config.prefixes.component +
                '-feedbackLoading"></div>'
        );
        var $canvas = $("<div></div>")
            .addClass(canvasClassName)
            .addClass(canvasClassName + "--in");

        var _windowObjectCreated = false;
        var _windowPlaced = false;
        var _windowPlaceHasBeenRequested = false;

        var afterWindowObjectCreated = function() {
            $window.appendTo($canvas);
            $loading.remove();

            if (_windowObjectCreated) return;
            _windowObjectCreated = true;

            $canvas.on(config.events.windowRequestClose, function(ev, params) {
                $('body').removeClass('u_noscroll');
                $canvas.addClass(canvasClassName + "--out");
                $window.trigger(config.events.windowOnBeforeClose, [params]);
                var extraParams = JSON.parse($canvas.css("content").unQuote());
                setTimeout(function() {
                    $canvas.remove();
                }, extraParams.stopAnimationMs);
            });
            if (!$window.params.captive) {
                $canvas.on("click", function(ev) {
                    if (ev.target === $canvas[0]) {
                        $canvas.trigger(config.events.windowRequestClose, {
                            isCancel: true
                        });
                    }
                });
            }
        };

        var afterWindowPlaced = function() {
            if (_windowPlaced) return;
            _windowPlaced = true;

            try {
                var extraParams = JSON.parse($canvas.css("content").unQuote());
            } catch (e) {
                var extraParams = {
                    stopAnimationMs: 500
                };
            }
            setTimeout(function() {
                $canvas.removeClass(canvasClassName + "--in");
            }, extraParams.stopAnimationMs);

            if ($window.params.url) {
                $(window).trigger(
                    config.events.routerRouteLoaded,
                    $window.params.url
                );
            }
            $window.trigger(config.events.windowOnLoad);
            $(window).trigger(config.events.significantDomChange);
        };

        /*public api*/
        this.place = function() {
            _windowPlaceHasBeenRequested = true;
            $("body").append($canvas).addClass("u_noscroll");

            if (_windowObjectCreated) {
                afterWindowPlaced();
            }

            setTimeout(function() {
                if (!_windowPlaced) $canvas.append($loading);
            }, 750);
        };

        this.on = function(ev, callback) {
            return $canvas.on(ev, callback);
        };

        /*actually trigger the window*/
        var params = getParams(_params);
        if (params.url) {
            var request = $.get(params.url, params.urlArgs);
            request.done(function(html, status, request) {
                params.html = html;
                if (
                    request.getResponseHeader("X-Request-Url") &&
                    request.getResponseHeader("X-Request-Url").length > 4
                ) {
                    params.url = request.getResponseHeader("X-Request-Url");
                }
                $window = makeWindow(params);
            });
            request.fail(function(jqxhr, status, error) {
                if (error == "Unauthorized") {
                    $window = makeWindow({
                        text:
                            'Hey, we need to know who you are before you can do that!<br><br>Please <a href="/auth/login">login</a> to continue.',
                        wrap: true,
                        autoscroll: false,
                        titlebar: true,
                        title: "Unauthorized",
                        width: "thin"
                    });
                } else {
                    $window = makeWindow({
                        text:
                            'Ooops, something went wrong on our end. Could you try again?<br/><small style="opacity:.25">' +
                            status +
                            " – " +
                            error +
                            "</small>",
                        wrap: true,
                        autoscroll: false,
                        titlebar: true,
                        title: "Error",
                        width: "thin"
                    });
                }
            });
            request.always(function() {
                afterWindowObjectCreated();
                if (_windowPlaceHasBeenRequested) {
                    afterWindowPlaced();
                }
            });
        } else {
            $window = makeWindow(params);
            afterWindowObjectCreated();
        }
        return this;
    };

    return Window;
});
